var exports = {
  "a": "Pill__CRQNhA",
};

module.exports = exports;
